import {getFormMessages} from '@wix/wix-events-commons-statics'
import {getExpandedTicketIndex, getTicketDetails, isAllTicketDetailsValid} from '../../../selectors/checkout'
import {getEvent} from '../../../selectors/event'
import {getSelectedTicketsArray} from '../../../selectors/selected-tickets'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {TicketsDetailsOwnProps, TicketsDetailsRuntimeProps} from './interfaces'
import {TicketsDetails as Presentation} from './tickets-details'

const mapRuntime = ({
  state,
  actions: {nextFormClicked, setExpandedTicketIndex},
}: DetailsPageAppProps): TicketsDetailsRuntimeProps => {
  const selectedTickets = getSelectedTicketsArray(state)
  return {
    selectedTickets,
    details: selectedTickets.map((_, index) => getTicketDetails(state, index)),
    allTicketDetailsValid: isAllTicketDetailsValid(state),
    messages: getFormMessages(getEvent(state)),
    expandedTicketIndex: getExpandedTicketIndex(state),
    nextFormClicked,
    setExpandedTicketIndex,
  }
}

export const TicketsDetails = connect<TicketsDetailsOwnProps, TicketsDetailsRuntimeProps>(mapRuntime)(Presentation)
